import { render, staticRenderFns } from "./WebServicePushListDataTable.vue?vue&type=template&id=04f61ff2&scoped=true"
import script from "./WebServicePushListDataTable.vue?vue&type=script&lang=js"
export * from "./WebServicePushListDataTable.vue?vue&type=script&lang=js"
import style0 from "./WebServicePushListDataTable.vue?vue&type=style&index=0&id=04f61ff2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f61ff2",
  null
  
)

export default component.exports